export function partition(items, condition) {
    return items.reduce(([truthy, falsy], element) => {
        if (condition(element)) {
            truthy.push(element);
        }
        else {
            falsy.push(element);
        }
        return [truthy, falsy];
    }, [[], []]);
}
export function mapBy(items, keyFn) {
    return items.reduce((acc, item) => {
        acc[keyFn(item)] = item;
        return acc;
    }, {});
}
//# sourceMappingURL=array-utils.js.map